import angular from 'angular';

import { leadForm } from './lead.form.directive';

export default angular.module('lead.form', []).directive('leadForm', leadForm);
